import type { SmartSearchResponse } from './types';

// API base URL - update this to your production domain
const API_BASE = window.location.hostname === 'localhost'
    ? 'http://localhost:8080'
    : 'https://api.floridacontractorverify.com';

/**
 * Search for Florida contractor licenses
 * @param query - Search query (name, license number, city, county, etc.)
 * @returns Promise with search results
 */
export async function searchLicenses(query: string): Promise<SmartSearchResponse> {
    const response = await fetch(`${API_BASE}/api/v1/search/smart?gated=false`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
    });

    if (!response.ok) {
        const errorText = await response.text().catch(() => 'Unknown error');
        throw new Error(`Search failed (${response.status}): ${errorText}`);
    }

    return response.json();
}
